import React, { useState } from 'react';
import {
  Paper,
  Tabs,
  Tab,
  Box,
} from '@mui/material';
import BookingManagement from './components/admin/BookingManagement';
import RoomManagement from './components/admin/RoomManagement';
import WalkInBooking from './components/admin/WalkInBooking';
import RoomAvailabilityMatrix from './components/admin/RoomAvailabilityMatrix';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 3 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Walk-in Booking" />
        <Tab label="Availability Matrix" />
        <Tab label="Bookings" />
        <Tab label="Rooms" />
      </Tabs>
      <Box>
        {activeTab === 0 && <WalkInBooking />}
        {activeTab === 1 && <RoomAvailabilityMatrix />}
        {activeTab === 2 && <BookingManagement />}
        {activeTab === 3 && <RoomManagement />}
      </Box>
    </Paper>
  );
};

export default AdminDashboard;